import { PostNumberAndCity } from "Components/Form/PostNumberAndCity";
import { RadioButtonTrueFalse } from "Components/Form/RadioButton";
import { useTexts } from "Components/TextContext";
import { OptionLabel } from "Components/TextContext/commonComponentEnums";
import { ProductBackendName } from "Features/CheckPrice/Products/productTypes";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { getError } from "Utils/productUtils";
import { FormikProps } from "formik";
import React from "react";
import { AddressSameAsHomeAddressAlert } from "../AkaHouseContents/ProductIntro/FormComponents/AddressSameAsHomeAddressAlert";

interface Props {
  formProps: FormikProps<any>;
  label: string;
  product?: ProductBackendName;
}

export const FindAddress = ({
  formProps,
  label,
  product,
}: Props): React.ReactElement => {
  const { getText } = useTexts();

  return (
    <>
      <RadioButtonTrueFalse
        direction="vertical"
        name="addressSameAsHomeAddress"
        id="addressSameAsHomeAddress"
        label={getText("houseform.label.addresssameashomeaddress")}
        error={getError("addressSameAsHomeAddress", formProps)}
        options={[
          {
            id: "addressSameAsHomeAddress-yes",
            label: getText(OptionLabel.BOOLEAN_YES),
            value: true,
          },
          {
            id: "addressSameAsHomeAddress-no",
            label: getText(OptionLabel.BOOLEAN_NO),
            value: false,
          },
        ]}
        onChange={() => {
          formProps.setFieldTouched("postNumber", false);
          formProps.setFieldTouched("recentlyBought", false);
        }}
      />
      {formProps.values.addressSameAsHomeAddress === BooleanFormType.FALSE && (
        <>
          {product && product === ProductBackendName.AKA_HOUSE_CONTENTS && (
            <AddressSameAsHomeAddressAlert />
          )}
          <PostNumberAndCity formProps={formProps} label={label} />
        </>
      )}
    </>
  );
};
